import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import SEO from "../components/SEO";
import { submitContactForm } from "../api/apiClient";
import FAQ from "../components/FAQ";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Initialize jQuery-based functionality safely
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length > 255) {
      newErrors.name = "Name must be less than 255 characters";
    }

    if (formData.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    if (formData.mobile_number) {
      const phoneRegex = /^[6-9]\d{9}$/;
      if (!phoneRegex.test(formData.mobile_number.replace(/\D/g, ""))) {
        newErrors.mobile_number = "Please enter a valid 10-digit mobile number";
      }
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.length > 2000) {
      newErrors.message = "Message must be less than 2000 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error("Please fix the errors in the form");
      return;
    }
    setIsSubmitting(true);

    try {
      const response = await submitContactForm(formData);
      if (response.status) {
        toast.success(response.message || "Message sent successfully");
        setFormData({
          name: "",
          email: "",
          mobile_number: "",
          message: "",
        });
      } else {
        toast.error(response.message || "Failed to send message");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us-page">
      <SEO
        title="Contact Us"
        description="Get in touch with Gateway Financial Services Limited. Our expert team is ready to assist you with personalized financial advisory, support, and investment queries."
      />

      {/* Banner Section */}
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{ backgroundImage: 'url("images/contactus-bg.jpg")' }}
            >
              <canvas id="canvas" />
              <div className="carousel-caption">
                <h1>Contact Us</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Page Content & Form */}
      <section id="welcome-section">
        <div className="container">
          <div className="row box-shadow border-rd">
            <div className="col-lg-5 px-0 contact-form-bg">
              <h3>Get in touch</h3>
              <form onSubmit={handleSubmit} id="hm-contact-form">
                <div className="controls">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="text"
                          required="required"
                          placeholder="Full name"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          name="name"
                          id="form_name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="invalid-feedback d-block text-danger font-sm mt-1">
                            {errors.name}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="email"
                          placeholder="Email"
                          className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          name="email"
                          id="form_email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback d-block text-danger font-sm mt-1">
                            {errors.email}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <input
                          type="tel"
                          placeholder="Phone no"
                          className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                          name="mobile_number"
                          id="form_phone"
                          value={formData.mobile_number}
                          onChange={handleChange}
                        />
                        {errors.mobile_number && (
                          <div className="invalid-feedback d-block text-danger font-sm mt-1">
                            {errors.mobile_number}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea
                          required="required"
                          rows={4}
                          placeholder="Message..."
                          className={`form-control ${errors.message ? "is-invalid" : ""}`}
                          name="message"
                          id="form_message"
                          value={formData.message}
                          onChange={handleChange}
                        />
                        {errors.message && (
                          <div className="invalid-feedback d-block text-danger font-sm mt-1">
                            {errors.message}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="lm-btn border-0"
                        disabled={isSubmitting}
                        style={{
                          cursor: isSubmitting ? "not-allowed" : "pointer",
                        }}
                      >
                        {isSubmitting ? "Sending..." : "Submit Now"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-7 px-0">
              <iframe
                title="Gateway Financial Services Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.9114662591965!2d88.3572094!3d22.544988999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02771945eb53bf%3A0xfdcac3d0fbbec2e4!2sGATEWAY%20FINANCIAL%20SERVICES%20LTD!5e0!3m2!1sen!2sin!4v1771935316546!5m2!1sen!2sin"
                width="100%"
                height={560}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
          <div className="row justify-content-center mt-5">
            <div className="col-lg-8 text-center">
              <div className="address-box box-shadow">
                <h4>Let's Connect With Us</h4>
                <p className="mb-3">
                  <i className="fa fa-map-marker" aria-hidden="true" /> Jasmine
                  Tower, 31, Shakespeare Sarani 2nd Floor,
                  <br /> Kolkata : 700017
                </p>
                <p>
                  <i className="fa fa-phone" aria-hidden="true" /> 033- 2289
                  4461
                </p>
                <p>
                  <i className="fa fa-envelope" aria-hidden="true" />{" "}
                  admin@gatewayfin.in
                </p>
                <hr />
                <h4 className="mb-3">Get in Touch With US</h4>
                <ul className="footer-social">
                  <li>
                    <a href="#linkedin" aria-label="LinkedIn">
                      <i className="fa fa-linkedin" aria-hidden="true" />
                    </a>
                  </li>
                  <li>
                    <a href="#twitter" aria-label="Twitter">
                      <i className="fa fa-twitter" aria-hidden="true" />
                    </a>
                  </li>
                  <li>
                    <a href="#instagram" aria-label="Instagram">
                      <i className="fa fa-instagram" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-12">
              <h4 className="text-center">
                Details Of Head Office and Branch Office
              </h4>
              <table className="table dwn-tbl table-bordered mb-5 con_tbl table-responsive-lg table-responsive-xl">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Stock Broker Name</th>
                    <th scope="col">Registration Number</th>
                    <th scope="col">Registered Address</th>
                    <th scope="col">Branch Address</th>
                    <th scope="col" style={{ width: 150 }}>
                      Contact No
                    </th>
                    <th scope="col" style={{ width: 250 }}>
                      Email Id
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Gateway Financial Services Limited Limited</td>
                    <td>INZ000247937</td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, Jasmine Tower, 2nd Floor, Kolkata 700
                      017
                    </td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, Jasmine Tower, 2nd Floor, Kolkata 700
                      017
                    </td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" /> +91
                      9007088081
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      helpdesk-support@gatewayfin.in
                    </td>
                  </tr>
                  <tr>
                    <td>Gateway Financial Services Limited Limited</td>
                    <td>INZ000247937</td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, Jasmine Tower, 2nd Floor, Kolkata 700
                      017
                    </td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 23B
                      N.S. Road, Dalhousie, Kolkata, 700001, West Bengal
                    </td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" /> +91
                      9831098322
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      helpdesk-support@gatewayfin.in
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 className="text-center">Escalation</h4>
              <table className="table dwn-tbl table-bordered con_tbl table-responsive-lg table-responsive-xl">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col" style={{ width: 100 }}>
                      Details
                    </th>
                    <th scope="col">Contact Person</th>
                    <th scope="col" style={{ width: 200 }}>
                      Contact Address
                    </th>
                    <th scope="col">Contact No.</th>
                    <th scope="col">Email</th>
                    <th scope="col">Working Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <b>Level 1</b> - <br />
                      Customer Care
                    </td>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Amberleen
                      Perrira
                    </td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, "Jasmine Tower" 2nd Floor, Kolkata-17
                    </td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      6292288368
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      feedback@gatewayfin.in
                    </td>
                    <td>
                      <i className="fa fa-clock-o" aria-hidden="true" /> 9:00am
                      - 7:00pm
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Level 2</b> - <br />
                      Head of Customer Care
                    </td>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Jayati
                      Dasgupta
                    </td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, "Jasmine Tower" 2nd Floor, Kolkata-17
                    </td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9836206380
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      igrgateway@gatewayfin.in
                    </td>
                    <td>
                      <i className="fa fa-clock-o" aria-hidden="true" /> 9:00am
                      - 7:00pm
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Level 3</b> - <br />
                      Compliance Officer
                    </td>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Ravi
                      Ranjan
                    </td>
                    <td>
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, "Jasmine Tower" 2nd Floor, Kolkata-17
                    </td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9007088081
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      compliance-legal@gatewayfin.in
                    </td>
                    <td>
                      <i className="fa fa-clock-o" aria-hidden="true" /> 9:00am
                      - 7:00pm
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Level 4</b> - <br />
                      CEO
                    </td>
                    <td className="con-inf">
                      <i className="fa fa-user" aria-hidden="true" /> Pratik
                      Agarwal
                    </td>
                    <td className="con-inf">
                      <i className="fa fa-map-marker" aria-hidden="true" /> 31,
                      Shakespeare Sarani, "Jasmine Tower" 2nd Floor, Kolkata-17
                    </td>
                    <td className="con-inf">
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9903629798
                    </td>
                    <td className="con-inf">
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      pratik@gatewayfin.in
                    </td>
                    <td className="con-inf">
                      <i className="fa fa-clock-o" aria-hidden="true" /> 9:00am
                      - 7:00pm
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row mt-5 mb-5">
            <div className="col-lg-3">
              <div className="cont-box">
                <h4>Level 1:</h4>
                <hr />
                <p>Trading &amp; Demat Account related queries:</p>
                <a href="mailto:helpdesk-support@gatewayfin.in">
                  <i className="fa fa-envelope" aria-hidden="true" />
                  helpdesk-support@gatewayfin.in
                </a>
                <p className="mb-0 con-inf">
                  <i className="fa fa-clock-o" aria-hidden="true" />{" "}
                  Monday–Friday from 9:00am to 7:00pm
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cont-box">
                <h4>Level 2:</h4>
                <hr />
                <p>
                  If you do not receive a satisfactory response at Level 1
                  within 3 working days, you may write to us at:
                </p>
                <p className="mb-2">
                  <b>Grievances:</b>
                </p>
                <a href="mailto:igr@gatewayfin.in">
                  <i className="fa fa-envelope" aria-hidden="true" />
                  igr@gatewayfin.in
                </a>
                <p className="mb-2">
                  <b>DP related queries/complaints:</b>
                </p>
                <a href="mailto:gatewaydp@gatewayfin.in">
                  <i className="fa fa-envelope" aria-hidden="true" />
                  gatewaydp@gatewayfin.in
                </a>
                <p className="mb-0 con-inf">
                  <i className="fa fa-clock-o" aria-hidden="true" />{" "}
                  Monday–Friday from 9:30am to 6:30pm
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cont-box">
                <h4>Level 3:</h4>
                <hr />
                <p>
                  If you still have not received a satisfactory response at
                  Level 2 within 3 working days, you may contact our Compliance
                  Officer at:
                </p>
                <p className="mb-2">
                  <b>Mr. Ravi Ranjan:</b>
                </p>
                <a href="mailto:compliance-legal@gatewayfin.in">
                  <i className="fa fa-envelope" aria-hidden="true" />
                  compliance-legal@gatewayfin.in
                </a>
                <a href="tel:+919007088081">
                  <i className="fa fa-phone" aria-hidden="true" /> +91
                  9007088081
                </a>
                <p className="mb-0 con-inf">
                  <i className="fa fa-clock-o" aria-hidden="true" />{" "}
                  Monday–Friday from 9:30am to 6:30pm
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cont-box">
                <h4>Level 4:</h4>
                <hr />
                <p>
                  If you have not received a satisfactory response at Level 3
                  within 7 working days, you may also approach our CEO at:
                </p>
                <p className="mb-2">
                  <b>Mr. Pratik Agarwal</b>
                </p>
                <a href="mailto:pratik@gatewayfin.in">
                  <i className="fa fa-envelope" aria-hidden="true" />
                  pratik@gatewayfin.in
                </a>
                <a href="tel:+919903629798">
                  <i className="fa fa-phone" aria-hidden="true" /> +91
                  9903629798
                </a>
                <p className="mb-0 con-inf">
                  <i className="fa fa-clock-o" aria-hidden="true" />{" "}
                  Monday–Friday from 9:30am to 6:30pm
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h4 className="text-center">KMP Details</h4>
              <table className="table dwn-tbl table-bordered con_tbl table-responsive-lg table-responsive-xl">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Name of KIMP</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Contact</th>
                    <th scope="col">Email ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Pinky
                      Agarwal
                    </td>
                    <td>Managing Director</td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9903989931
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      agarwalpinky1993@gmail.com
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Pratik
                      Agarwal
                    </td>
                    <td>Whole-Time Director</td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9903629798
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      pratik@gatewayfin.in
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Nishit
                      Agarwal
                    </td>
                    <td>Chief Financial Officer</td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9674737336
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      nishit@gatewayfin.in
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <i className="fa fa-user" aria-hidden="true" /> Ravi
                      Ranjan
                    </td>
                    <td>Compliance Officer</td>
                    <td>
                      <i className="fa fa-phone" aria-hidden="true" />{" "}
                      9007088081
                    </td>
                    <td>
                      <i className="fa fa-envelope" aria-hidden="true" />{" "}
                      compliance-legal@gatewayfin.in
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#app-section" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="images/app-pic.jpg"
                className="img-fluid"
                alt="Investment Fund App"
              />
            </div>
          </div>
        </div>
      </section>
      <FAQ />
    </div>
  );
};

export default ContactUs;
